import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {  } from "../actions/localStates"
import {  } from "../actions/api"

import CreateDSView from '../components/CreateDSView';

class CreateContainer extends Component {

	render() {
		return (
			<CreateDSView />
		);
	}
}

function mapStateToProps(state) {
    return {
        base: state.base
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
 
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateContainer);